<template>
  <div class="header">
    <!-- <p class="language">语言版本： <span v-bind:class="{active: isActive}" @click="changeLanguage">中文</span><span @click="changeLanguage" v-bind:class="{active: !isActive}">ENG</span></p> -->
    <div class="header-box">
      <div class="header-nav clearfix">
        <a href="/"><img src="./logo.png" alt="亚商集团" class="fl"></a>
        <ul class="nav-list" id="nav-list">
          <li
            :class="{
            'nav-list-hover': item.linkItem === '走进亚商',
            'big-home-hover':item.linkItem === '亚商大家庭',
            'custom-li':item.linkItem === '亚洲商务大学堂'
            }"
            v-for="(item, index) in headerList"
            :key="index">
            <a
              :href="item.name"
              :style="{color: activeName === item.linkItem ? '#A61E3E' : '#0E4B8C'}"
            >{{item.linkItem}}
              <span
              v-if="(item.linkItem === '走进亚商') || (item.linkItem === '亚商大家庭') || (item.linkItem === '亚洲商务大学堂')"
              class="catalogArrow"></span>
            </a>
            <p v-if="item.linkItem === '亚洲商务大学堂'">
              <a
                :style="{color: activeName === item.linkItem ? '#A61E3E' : '#0E4B8C'}"
                href="/university-hall"
              >Academy of Asia+ Business</a>
            </p>
            <ul class="second-list" v-if="(item.linkItem === '走进亚商')">
              <li v-for="(secondItem1, secondIndex1) in secondList1" :key="secondIndex1">
                <a :href="`/gotoContent/${secondItem1.name}`"><span></span>{{secondItem1.linkItem}}</a>
              </li>
            </ul>
            <ul class="second-list" v-if="item.linkItem === '亚商大家庭'">
              <li><a href="http://www.abccapital.cn" target="_blank">亚商资本</a></li>
              <li><a href="https://www.abctougu.cn" target="_blank">亚商投顾</a></li>
              <li><a href="https://www.abcintel.cn/" target="_blank">亚商智讯</a></li>
              <li><a href="https://www.30zjs.cn/" target="_blank">正经塾</a></li>
              <li><a href="http://www.yrdfintech.org/" target="_blank">长三角金科大赛</a></li>
            </ul>
            <ul class="second-list" v-if="item.linkItem === '亚洲商务大学堂'">
              <li v-for="(secondItem2, secondIndex2) in secondList2" :key="secondIndex2">
                <a :href="secondItem2.name"><span></span>{{secondItem2.linkItem}}</a>
              </li>
          </ul>
          </li>
        </ul>
        <a href="/anniversary" target="_blank" class="thirty-year fr"><img src="./30year-icon.png" alt=""></a>
      </div>
    </div>

  </div>
</template>

<script>

  export default{
    name: 'Header',
    data(){
      return {
        isActive: true,
        matchedRoute: null,
        headerList: [
          {
            linkItem: '走进亚商',
            name: '/'
          },
          {
            linkItem: '亚商文化',
            name: '/culture'
          },
          {
            linkItem: '亚商动态',
            name: '/news-list'
          },
          {
            linkItem: '亚商大家庭',
            name: '/bigHome'
          },
          {
            linkItem: '社会责任',
            name: '/responsibility'
          },
          {
            linkItem: '亚洲商务大学堂',
            name: '/university-hall'
          }
        ],
        secondList1: [
          {
            linkItem: '亚商简介',
            name: 'introduce'
          },
          {
            linkItem: '发展历程',
            name: 'developHistory'
          },
          {
            linkItem: '核心团队',
            name: 'founder'
          },
          {
            linkItem: '联系我们',
            name: 'contactUs'
          },
          {
            linkItem: '加入我们',
            name: 'joinUs'
          }
        ],
        secondList2: [
          {
            linkItem: '关于我们',
            name: '/university-hall'
          },
          {
            linkItem: '研修体系',
            name: '/research-system'
          },
          {
            linkItem: '理事会',
            name: '/trustee-council'
          },
          {
            linkItem: '导师团队',
            name: '/mentor-team'
          }
        ],
        activeName: '走进亚商'
      }
    },
    created(){
      this.activeName = this.$route.matched.length ? this.$route.matched[0].name : '亚商动态';
      localStorage.setItem('headerActiveName', this.activeName);
    },
    methods: {
      changeLanguage: function(){
        this.isActive = !this.isActive;
      },
      //跳转至30周年庆页面
      gotoAnniversaryPage(){
        this.$openNewPage(`/anniversary`)
      }
    }
  }
</script>

<style scoped>
  .header{
    position: relative;
    background: #fff;
    position: fixed;
    top: 0;
    z-index: 2;
  }
  .header,.header-box{
    background: #fff;
    width: 100%;
    /* height: 80px; */
    min-width: 1200px;
  }
  .header-box{
    position: relative;
  }
  .header .thirty-year{
    position: absolute;
    top: -8px;
    right: 12%;
    z-index: 9;
  }
  .header-box{
    height: 120px;
    padding: 15px 0;
    box-sizing: border-box;
    background-color: #fff;
  }
  .header-nav,.header .language{
    max-width: 1200px;
    margin: 0 auto;
  }
  .header-nav{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .language{
    padding-top: 15px;
    line-height: 22px;
    font-size: 12px;
    text-align: right;
    color: #666;
  }
  .language span{
    display: inline-block;
    width: 60px;
    text-align: center;
    cursor: pointer;
  }
  .language .active{
    background: #003B83;
    color: #fff;
  }
  .nav-list{
    display: flex;
    flex: 1;
    height: 87px;
    box-sizing: border-box;
    padding-left: 100px;
    padding-top: 40px;
  }
  .nav-list img{
    vertical-align: middle;
  }
  .nav-list a{
    display: block;
  }
  .nav-list .catalogArrow{
    background: url('./slide-gray.png') no-repeat 0 0;
    display: inline-block;
    width: 11px;
    height: 7px;
    vertical-align: middle;
    background-size: 11px 7px;
  }
  ul li{
    position: relative;
    width: 120px;
    height: 87px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    float: left;
  }
  ul .custom-li{
    width: 160px;
    text-align: center;
  }
  ul .custom-li ul{
    left: 20px;
  }
  ul .custom-li:hover ul{
    left: 20px;
    height: 184px;
    transition: height 0.35s ease;
  }
  ul .custom-li p{
    font-size: 12px;
    margin-top: 5px;
  }
  ul .custom-li p a{
    color: #0E4B8C;
  }
  ul > li > a{
    color: #0E4B8C;
  }
  .nav-list .nav-list-hover:hover ul{
    height: 230px;
    transition: height 0.35s ease;
  }
  .big-home-hover:hover ul{
    height: 230px;
    transition: height 0.35s ease;
  }
  .second-list{
    width: 120px;
    height: 0;
    position: absolute;
    top: 37px;
    left: 0;
    /*display: none;*/
    z-index: 999;
    background: #232323;
    overflow: hidden;
    transition: height 0.35s ease;
  }
  .second-list li{
    height: 46px;
    line-height: 46px;
  }
  .second-list li span{
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
  }
  .second-list li a{
    color: #B8B8B8;
  }
  .second-list li:hover{
    background: #323133;
  }
  .second-list li:hover a{
    color: #ffffff;
  }
  .second-list li:hover span{
    display: inline-block;
    width: 12px;
    height: 17px;
    background: url('./arrow.png') no-repeat 0 0;
    vertical-align: middle;
    margin-right: 4px;
    background-size: 12px 17px;
  }
  @media screen and (max-width: 1800px){
    .header .nav-list{
      margin-right: 100px;
    }
    .header .thirty-year{
      right: 11%;
    }
  }
  @media screen and (max-width: 1800px){
    .header .thirty-year{
      right: 8%;
    }
  }
  @media screen and (max-width: 1500px){
    .header .nav-list{
      padding-left: 30px;
    }
    .header .thirty-year{
      right: 5%;
    }
  }
  @media screen and (max-width: 1330px){
    .header .thirty-year{
      right: 0%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/header/Header.vue